import React, { Component } from "react";
import $ from "jquery";
import DataTable from "react-data-table-component";
import { Link } from "react-router-dom";

export default class PatientJournalResultStatus extends Component {
  constructor() {
    super();

    this.state = {
      journalQuestions: [],
      journalTitle: localStorage.getItem("journalTitle"),
      dateBasedJournalEntries: [],
      isLoading: true,
    };
  }

  componentDidMount() {
    var thisController = this;
    setTimeout(() => {
      thisController.fetchJournalQuestions();
      thisController.fetchJournalSummationConfig();
    }, 300);
  }

  fetchJournalQuestions() {
    var thisController = this;
    let patientId = localStorage.getItem("patientAdmissionId");

    $.ajax({
      url: "/my-jeeva-api/fetch-journal-item",

      method: "GET",
      headers: {
        Authorization: "Bearer " + localStorage.getItem("access_token"),
      },
      data: {
        answeredBy: patientId,
        journalId: localStorage.getItem("journalId"),
      },
      success: function (res) {
        if (res.success == true) {
          var resp = res.result;
          thisController.state.journalQuestions = resp;
          thisController.setState(thisController.state);
          thisController.questionLabelToObjectMap = {};
          for (var i = 0; i < resp.length; i++) {
            var journalQuestion = resp[i];
            thisController.questionLabelToObjectMap[journalQuestion.label] =
              journalQuestion;
          }
          console.log(resp);
        }
      },
    });
  }
  

  fetchJournalAnswers() {
    var thisController = this;
    let patientId = localStorage.getItem("patientAdmissionId");
    var userTimeZone = Intl.DateTimeFormat().resolvedOptions().timeZone;

    $.ajax({
      url: "/my-jeeva-api/fetch-date-filter-journal-entry",
      method: "GET",
      headers: {
        Authorization: "Bearer " + localStorage.getItem("access_token"),
      },
      data: {
        journalId: localStorage.getItem("journalId"),
        answeredBy: patientId,
        startDate: localStorage.getItem("entryStartDate"),
        endDate: localStorage.getItem("entryEndDate"),
        timeZone: userTimeZone
      },
      success: function (res) {
        if (res.success == true) {
          var date;
          var dateString;
          var dateJournalEntryMap = {};
          var journalEntries = res.result;
          var dayStartString;
          if (thisController.summConfigObject) {
            dayStartString =
              thisController.summConfigObject.startOfDay + ":00 AM";
            var dayStartTime = new Date("2000-01-01 " + dayStartString); // assuming dummy date
          } else {
            dayStartString = "12:00 AM";
            var dayStartTime = new Date("2000-01-01 " + dayStartString);
          }

          journalEntries.forEach((journalEntry) => {

            journalEntry.answerJsonRecord = JSON.parse(
              journalEntry.answersJson
            );
            var hasCustomDateOrTime = false;
            var patientAnswerTime = new Date(journalEntry.answeredOn);
            var customDateString = false;
            if (thisController.summConfigObject) {
              if (thisController.summConfigObject.sumBy != 'systemDate' && thisController.summConfigObject.sumBy.length > 0) {
                var sumByKey = thisController.summConfigObject.sumBy;
                var sumByQuestionId = thisController.questionLabelToObjectMap[sumByKey].id;
                var customPatientDataDateString = journalEntry.answerJsonRecord[sumByQuestionId];
                if (customPatientDataDateString) {
                  customDateString = customPatientDataDateString;
                  hasCustomDateOrTime = true;
                }
              }
            }
            var customTimeString = false;
            if (thisController.summConfigObject) {
              if (thisController.summConfigObject.sumByTime != 'systemTime' && thisController.summConfigObject.sumByTime.length > 0) {
                var sumByTimeKey = thisController.summConfigObject.sumByTime;
                if (sumByTimeKey) {
                  var sumByTimeQuestionId = thisController.questionLabelToObjectMap[sumByTimeKey].id;
                  var customPatientDataTimeString = journalEntry.answerJsonRecord[sumByTimeQuestionId];
                  if (customPatientDataTimeString) {
                    if (customPatientDataTimeString.includes("undefined")) {
                      customPatientDataTimeString = customPatientDataTimeString.replace(" undefined", "");
                      journalEntry.answerJsonRecord[sumByTimeQuestionId] = customPatientDataTimeString;
                    }
                    customTimeString = customPatientDataTimeString + ":00";
                    hasCustomDateOrTime = true;
                  }
                }
              }
            }

            var dataDate = thisController.getDateAsSimpleString(patientAnswerTime);
            var dataTime = patientAnswerTime.getHours() + ":" + patientAnswerTime.getMinutes() + ":00";

            if (customDateString !== false) {
              dataDate = customDateString;
            }
            if (customTimeString !== false) {
              dataTime = customTimeString;
            }

            if (hasCustomDateOrTime === true) {
              var dataDateAndTime = dataDate + " " + dataTime;
              patientAnswerTime = new Date(dataDateAndTime);
              journalEntry.answeredOn = patientAnswerTime.getTime();
            }


            var timeInMinutesSince12am = patientAnswerTime.getHours() * 60 + patientAnswerTime.getMinutes();
            var dayStartInMinsSince12am = dayStartTime.getHours() * 60 + dayStartTime.getMinutes();

            if (timeInMinutesSince12am < dayStartInMinsSince12am) {
              var actualDate = new Date(patientAnswerTime.getTime());
              patientAnswerTime.setDate(patientAnswerTime.getDate() - 1);
              journalEntry.actualDate = thisController.getDateAsSimpleString(actualDate);
            }
            dateString = thisController.getDateAsSimpleString(patientAnswerTime);

            if (!dateJournalEntryMap[dateString]) {
              dateJournalEntryMap[dateString] = [];
            }

            dateJournalEntryMap[dateString].push(journalEntry);
          });
          console.log("Summation config:" + thisController.summConfigObject);

          if (thisController.summConfigObject) {
            var sumOnFields = thisController.summConfigObject.sumOn;

            if (sumOnFields.length > 0 && sumOnFields[0].label != "") {
              for (dateString in dateJournalEntryMap) {
                var sumRow = {};
                sumRow.answeredOn = "Total";
                sumRow.answerJsonRecord = {};
                var dateJournalRows = dateJournalEntryMap[dateString];

                for (
                  var sumOnIndex = 0;
                  sumOnIndex < sumOnFields.length;
                  sumOnIndex++
                ) {

                  var sumOnField = sumOnFields[sumOnIndex].label;
                  if (sumOnField) {
                    var questionId =
                      thisController.questionLabelToObjectMap[sumOnField].id;
                    console.log("Calculating sum of " + sumOnField);
                    var sum = 0;
                    for (
                      var entryIndex = 0;
                      entryIndex < dateJournalRows.length;
                      entryIndex++
                    ) {
                      var answerJsonRecord =
                        dateJournalRows[entryIndex].answerJsonRecord;
                      var sumOnFieldValue = answerJsonRecord[questionId]
                        ? answerJsonRecord[questionId]
                        : 0;
                      sum += Number(sumOnFieldValue);
                    }
                    sumRow.answerJsonRecord[questionId] = sum;
                    console.log(
                      "Calculated sum of " +
                      sumOnField +
                      " for " +
                      dateString +
                      " is " +
                      sum
                    );
                  }
                }
                dateJournalRows.push(sumRow);
              }
            }
          }

          var dateJournalEntries = [];
          var dateJournalEntry;

          for (dateString in dateJournalEntryMap) {
            dateJournalEntry = {
              date: dateString,
              entries: dateJournalEntryMap[dateString],
            };
            dateJournalEntries.push(dateJournalEntry);
          }

          thisController.state.dateBasedJournalEntries = dateJournalEntries;
          thisController.state.isLoading = false;
          thisController.setState(thisController.state);
        }
      },
    });
  }
  fetchJournalSummationConfig() {
    var thisController = this;
    $.ajax({
      url: "/my-jeeva-api/get-journal-Summation",
      method: "GET",
      data: {
        journalId: localStorage.getItem("journalId"),
      },
      headers: {
        Authorization: "Bearer " + localStorage.getItem("access_token"),
      },
      success: function (res) {
        if (res.success == true) {
          console.log("response object: ", res.result);
          var summConfigObject = res.result;
          var selectedData = summConfigObject.sumOn.split(",");
          var sumOnArray = [];
          for (let label of selectedData) {
            sumOnArray.push({ label });
          }
          summConfigObject = { ...summConfigObject, sumOn: sumOnArray };
          thisController.summConfigObject = summConfigObject;
        }
        thisController.fetchJournalAnswers();
      },
    });
  }
  getDateAsSimpleString(dateObj) {
    var month = dateObj.getMonth() + 1;
    var day = dateObj.getDate();
    if (day < 10) {
      day = "0" + day;
    }
    if (month < 10) {
      month = "0" + month;
    }
    return month + "/" + day + "/" + dateObj.getFullYear();
  }


  formatTime(longDate, actualDate) {
    var totalString = "Total";
    if (longDate == totalString) {
      return totalString;
    }
    var date = new Date(longDate);
    var hours = date.getHours();
    var minutes = date.getMinutes();
    var ampm = hours >= 12 ? "pm" : "am";
    hours = hours % 12;
    hours = hours ? hours : 12; // the hour '0' should be '12'
    minutes = minutes < 10 ? "0" + minutes : minutes;
    var strTime = hours + ":" + minutes;
    if (ampm === "pm") {
      if (hours !== 12) {
        hours = parseInt(hours) + 12; // Add 12 to hours if pm and not already 12
      }
      strTime = hours + ":" + minutes;
    }
    else {
      if (hours === 12) {
        hours = "00"; // Change 12 AM to 00 AM
      }
      strTime = hours + ":" + minutes;
    }
    return strTime;
  }
  CustomNoDataComponent = () => (
    <div style={{ padding: '20px', textAlign: 'center' }}>
      <p>There are no journal result present. </p>
    </div>
  );

  extractCellValueAndColor(answersJsonRecord, questionId, type, answeredOn, journalQuestions) {
    var value = answersJsonRecord[questionId];
    var backgroundColor = ""; // Initialize background color
    var color = "";

    if (Array.isArray(value)) {
      value = value.join(","); // Join array elements with comma
    }

    if (!value) {
      if (type === "INTEGER") {
        value = "NA";
      } else {
        value = "NA";
      }
    }

    // Logic to change background color
    if (answeredOn === "Total") {
      var jsonObject = answersJsonRecord;
      if (jsonObject) {
        for (var key in jsonObject) {
          if (jsonObject.hasOwnProperty(key)) {
            var answerKey = key
            if (answerKey === questionId) {
              for (var keyIndex = 0; keyIndex < journalQuestions.length; keyIndex++) {
                if (journalQuestions[keyIndex].id === questionId) {
                  var value = jsonObject[answerKey];
                  console.log("Key: " + answerKey + ", Value: " + value);
                  var threshold = journalQuestions[keyIndex].threshold;
                  console.log("threshold", threshold);
                  if (threshold && value > 0) {
                    var result = (value / threshold) * 100;
                    console.log("result", result);
                    if (result > 100) {
                      backgroundColor = "red";
                      color = "white";
                    } else if (result < 100 && result >= 75) {
                      backgroundColor = "yellow";
                      color = "black"
                    } else {
                      backgroundColor = "green";
                      color = "white";
                    }
                  }
                }
              }

            }
          }

        }
      }

    }

    return { value, backgroundColor, color };
  }


  getColumns(dateBasedJournalEntry) {
    console.log(dateBasedJournalEntry.date);
    var thisController = this;
    var columns = [
      {
        name: <b style={{ fontSize: "16px" }}>{dateBasedJournalEntry.date}</b>,
        selector: (props) => {
          return (
            <div
              className="textarea"
              style={{
                background: "white",
                height: "2.7em",
                resize: "none",
                paddingLeft: "13px",
                paddingTop: "6px",
                width: "100%",
                border: "none",
                borderRadius: "2px",
                textAlign: "center",
              }}
            >
              {thisController.formatTime(props.answeredOn, props.actualDate)}
            </div>
          );
        },
      },
    ];
    var journalQuestion;

    for (var i = 0; i < this.state.journalQuestions.length; i++) {
      journalQuestion = this.state.journalQuestions[i];
      console.log("Adding column header : " + journalQuestion.label);

      columns.push({
        name: <b style={{ fontSize: "16px" }}>{journalQuestion.label}</b>,
        selector: (function (journalQuestion) {
          return (props) => {
            var result = thisController.extractCellValueAndColor(
              props.answerJsonRecord,
              journalQuestion.id,
              journalQuestion.type,
              props.answeredOn,
              thisController.state.journalQuestions
            );

            var threshold = journalQuestion.threshold;
            if (threshold) {
              var backgroundColor = threshold ? result.backgroundColor : "white"; // Set background color only if threshold exists
              var color = threshold ? result.color : "black"; // Set color only if threshold exists

            } else {
              backgroundColor = "white";
              color = "black";
            }

            return (
              <div
                className="textarea"
                style={{
                  background: backgroundColor, // Set background color here
                  height: "2.7em",
                  resize: "none",
                  paddingLeft: "13px",
                  paddingTop: "6px",
                  width: "100%",
                  border: "none",
                  borderRadius: "2px",
                  textAlign: "center",
                  color: color,
                }}
              >
                {result.value}
              </div>
            );
          };
        })(journalQuestion),
      });
    }

    return columns
  }

  handleDateChange = () => {
    var today = new Date();
    const resultDate = new Date(today);
    resultDate.setDate(today.getDate() - 10);
    localStorage.setItem("entryEndDate", today);
    localStorage.setItem("entryStartDate", resultDate);
  }

  render() {
    const customStyles = {
      headCells: {
        style: {
          justifyContent: "center",
          width: "10vw"
        }
      },

      cells: {
        style: {
          justifyContent: "center",
          width: "10vw"
        },
      },

    };
    return (
      <div>
        {/* <div
          style={{
            display: "flex",
            justifyContent: "start",
            marginTop: "10px",
          }}
        >
          <Link to="/projectmgmt/view-patient-journal-status">
            <img
              className="img-responsive"
              src="./assets/images/arrow.svg"
              style={{ marginLeft: "5px", cursor: "pointer" }}
            />
          </Link>

          <h6
            className="nav-item"
            style={{ color: "#282a65", marginTop: "4px", marginLeft: "9px" }}
          >
            {localStorage.getItem("journalTitle")}
          </h6>
        </div> */}
        <div className="row">
          <div className="col-sm-4" style={{ marginTop: '16px' }}  >
            <Link to="/projectmgmt/reports/dashboard-table">
              <img src="./assets/images/arrow.svg"
                style={{ paddingRight: "30%", cursor: 'pointer' }}
                onClick={this.handleDateChange}
              />
            </Link>
          </div>
          <div className="col-sm-4">
            <h6 className="nav-item" style={{ color: '#282a65', textAlign: 'center', marginTop: '16px' }}>
              {localStorage.getItem("journalTitle")}</h6>

          </div>
        </div>
        <br></br>
        {this.state.isLoading && (
          <div style={{ padding: '20px', textAlign: 'center', boxShadow: "0 0 10px rgba(0, 0, 0, 0.2)" }}>
            <p>Loading ...</p>
          </div>
        )}
        {!this.state.isLoading && this.state.dateBasedJournalEntries.length == 0 && (
          <div style={{ padding: '20px', textAlign: 'center', boxShadow: "0 0 10px rgba(0, 0, 0, 0.2)" }}>
            <p>There are no journal result present. </p>
          </div>
        )}
        {this.state.dateBasedJournalEntries.length > 0 && (this.state.dateBasedJournalEntries.map((dateBasedJournalEntry) => (
          <div style={{ boxShadow: "0 0 10px rgba(0, 0, 0, 0.2)", marginBottom: "10px" }}>
            <DataTable
              columns={this.getColumns(dateBasedJournalEntry)}
              data={dateBasedJournalEntry.entries}
              customStyles={customStyles}
              noDataComponent={<this.CustomNoDataComponent />}
            />
          </div>
        )))}



      </div>
    );
  }
}



// WEBPACK FOOTER //
// src/my-jeeva/projectmgmt/PatientJournalResultStatus.js